import React from "react"

import { TextBox, CheckBox } from '../Shared/FormHelpers'
import { FileUpload } from "./Styles/Platform.style";
import SkillSetForm from './SkillSetForm';
import WorkExperienceForm from './WorkExperienceForm';
import EducationForm from './EducationForm';
import {Row} from "./Resumes/Styles/Resume.styles";

const ProfileDetailForm = ({
  profile,
  handleChange,
  addSkillSet,
  addEducation,
  addWorkExperience,
  deleteEducation,
  deleteSkillSet,
  deleteWorkExperience,
}) => {
  return (
    <div>
      <div className="row">
        <div className="col-lg-4">
          <div className="form-group">
            <label>Title</label>
            <TextBox
              type="text"
              className="form-control form-control-lg"
              name="title"
              placeholder="Desired Position"
              onChange={handleChange}
              value={profile.title}
              required
            />
          </div>
        </div>
        <div className="col-lg-4">
          <div className="form-group">
            <label>Type</label>
            <select
              className="form-control form-control-lg"
              name="position_type"
              value={profile.position_type}
              onChange={handleChange}
            >
              <option>Employment type</option>
              <option>Full-time</option>
              <option>Contract</option>
              <option>Part-Time</option>
            </select>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="form-group">
            <label>Annual Salary:</label>
            <TextBox
              className="form-control form-control-lg"
              name="salary"
              placeholder="Salary"
              onChange={handleChange}
              value={profile.salary}
              required
            />
          </div>
        </div>
        <div className="col-lg-2">
          <div className="form-group">
            <label>Hourly Rate:</label>
            <TextBox
              className="form-control form-control-lg"
              name="hourly_rate"
              placeholder="Hourly Rate"
              precision="2"
              onChange={handleChange}
              value={profile.hourly_rate || 0}
              required
            />
          </div>
        </div>
      </div>
      <hr />
      <Row>
        <div className="col col-lg-4">
          <div className="form-group">
            <p style={{ padding: "10% 0", textAlign: "center" }}>
              {profile.resume && profile.resume[0].name
                ? profile.resume[0].name
                : "Upload resume"}
            </p>
          </div>
        </div>
        <div className="col">
          <div className="form-group">
            <FileUpload for="upload">
              {profile.resume && profile.resume[0].name
                ? "Change your Resume"
                : "Upload File"}
              <input
                id="upload"
                name="resume"
                type="file"
                onChange={handleChange}
              />
            </FileUpload>
          </div>
        </div>
      </Row>
      <hr />
      <div className="row">
        <div className="col-lg-3">
          <div className="form-check">
            <label>Able to Relocate?</label>
            <div className="searchable">
              <label className="form-check-label">
                <CheckBox
                  name="relocate"
                  onChange={handleChange}
                  checked={profile.relocate}
                />
                Yes
              </label>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-check">
            <label>US Citizen?</label>
            <div className="searchable">
              <label className="form-check-label">
                <CheckBox
                  name="us_citizen"
                  onChange={handleChange}
                  checked={profile.us_citizen}
                />
                Yes
              </label>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-check">
            <label>Security Clearance?</label>
            <div className="searchable">
              <label className="form-check-label">
                <CheckBox
                  name="security_clearance"
                  onChange={handleChange}
                  checked={profile.security_clearance}
                />
                Yes
              </label>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-check">
            <label>Military Veteran?</label>
            <div className="searchable">
              <label className="form-check-label">
                <CheckBox
                  name="veteran"
                  onChange={handleChange}
                  checked={profile.veteran}
                />
                Yes
              </label>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <SkillSetForm
        profile={profile}
        save={addSkillSet}
        delete={deleteSkillSet}
      />
      <hr />
      <WorkExperienceForm
        profile={profile}
        add={addWorkExperience}
        delete={deleteWorkExperience}
      />
      <hr />
      <EducationForm
        profile={profile}
        add={addEducation}
        delete={deleteEducation}
      />
    </div>
  );
};

export default ProfileDetailForm;
